<template>
  <div class="mark-lp-base" :style="styles">

    <div class="lp-block1 lp-block" v-intersection ref="lpblock1">
      <div class="top-visual">
        <div class="img-wrap">
          <img class="upper obj1" src="/static/img/mark_lp/houen/hoen_m_lp_01_01.png">
          <img class="upper obj2" src="/static/img/mark_lp/houen/hoen_m_lp_01_02.png">
          <img class="upper obj3" src="/static/img/mark_lp/houen/hoen_m_lp_01_03.png">
          <img class="upper obj4" src="/static/img/mark_lp/houen/hoen_m_lp_01_04.png">
          <img class="upper numbers num01" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num01.png">
          <img class="upper numbers num02" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num02.png">
          <img class="upper numbers num03" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num03.png">
          <img class="upper numbers num04" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num04.png">
          <img class="upper numbers num05" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num05.png">
          <img class="upper numbers num06" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num06.png">
          <img class="upper numbers num07" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num07.png">
          <img class="upper numbers num08" src="/static/img/mark_lp/houen/hoen_m_lp_01_bg_num08.png">

          <img class="upper obj4" src="/static/img/mark_lp/houen/hoen_m_lp_01_04.png">
          <div class="bgtop">
            <img src="/static/img/mark_lp/houen/hoen_m_lp_01_bg.png">
          </div>
        </div>
      </div>
      <img class="obj5" src="/static/img/mark_lp/houen/hoen_m_lp_01_05.png">
      <div class="btn-area">
        <div
          v-intersection
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ占う</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">占いTV月額会員ログインは<span
          class="login-link"
          @click.prevent="onLinkClick({
            target: 'utv-login',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">こちら</span></span>
      </div>
    </div>

    <div class="lp-block2 lp-block">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_02_01.png">
      <div class="img-wrap" v-intersection>
        <img class="face" src="/static/img/mark_lp/houen/hoen_m_lp_02_02.png">
        <img class="fuki upper" src="/static/img/mark_lp/houen/hoen_m_lp_02_03.png">
      </div>
      <div class="slide-area">
        <swiper :options="swiperOption" ref="mySwiper1">
          <swiper-slide><img src="/static/img/mark_lp/houen/hoen_banner_01.png"></swiper-slide>
          <swiper-slide><img src="/static/img/mark_lp/houen/hoen_banner_02.png"></swiper-slide>
          <!-- <swiper-slide><img src="/static/img/mark_lp/houen/hoen_banner_03.png"></swiper-slide> -->
        </swiper>
        <span class="notice">※メニュー名：あなたが目をそらしてきた本当の自分［黒密裏］は？　より</span>
      </div>
      <img src="/static/img/mark_lp/houen/hoen_m_lp_02_04.png">
      <div class="btn-area" v-intersection>
        <div
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ占う</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">※一部別料金あり</span>
      </div>
    </div>

    <div class="lp-block3 lp-block">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_03_01.png">
      <div class="slide-area">
        <swiper :options="swiperOption2" ref="mySwiper2">
          <!-- <swiper-slide><img src="/static/img/mark_lp/houen/hoen_banner_01.png"></swiper-slide>-->
          <!-- <swiper-slide><img src="/static/img/mark_lp/houen/hoen_banner_02.png"></swiper-slide>-->
          <swiper-slide><img src="/static/img/mark_lp/houen/hoen_banner_03.png"></swiper-slide>
        </swiper>
        <span class="notice">※メニュー名：運命の人の顔の特徴は「XX」、名前は「○」がつくひとより</span>
      </div>
      <div class="btn-area" v-intersection>
        <div
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ占う</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">※一部別料金あり</span>
      </div>
    </div>

    <div class="lp-block4 lp-block">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_03_02.png">
      <div class="btn-area" v-intersection>
        <div
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ占う</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">※一部別料金あり</span>
      </div>
    </div>

    <div class="lp-block5 lp-block">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_03_03.png">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_03_04.png">
      <div class="btn-area" v-intersection>
        <div
          v-intersection
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ占う</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">※一部別料金あり</span>
      </div>
    </div>

    <div class="lp-block6 lp-block">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_04_01.png">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_04_02.png">
      <div class="btn-area upper" v-intersection>
        <div
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ占う</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">※一部別料金あり</span>
      </div>
      <img src="/static/img/mark_lp/houen/hoen_m_lp_04_01.png">
    </div>

    <div class="lp-block7 lp-block">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_05_01.png">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_05_02.png">
      <div class="btn-area middle" v-intersection>
        <div
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ登録</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">※一部別料金あり</span>
      </div>
      <img src="/static/img/mark_lp/houen/hoen_m_lp_05_03.png">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_05_04.png">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_05_05.png">
      <div class="btn-area" v-intersection>
        <div v-intersection class="tgt-btn" @click.prevent="onLinkClick('utv-userinput')">占いTVに入会する</div>
      </div>

      <img src="/static/img/mark_lp/houen/hoen_m_lp_05_06.png">
      <div class="btn-area lower" v-intersection>
        <div
          class="tgt-btn tgt-btn1"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_year',
            ga_value: 1
          })">占いTVに入会する</div>
        <div
          class="tgt-btn tgt-btn2 yearluck"
          @click.prevent="onLinkClick({
            target: 'utv-yearluck',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_year',
            ga_value: 1
          })"><span class="subtitle">2022年下半期運勢を</span>購入する</div>
        <span class="notice">占いTV月額528円（税込）</span>
        <span class="notice">※一部別料金あり</span>
      </div>
    </div>

    <div class="lp-block8 lp-block">
      <img src="/static/img/mark_lp/houen/hoen_m_lp_05_07.png">
      <div class="btn-area" v-intersection>
        <div
          class="tgt-btn"
          @click.prevent="onLinkClick({
            target: 'utv-userinput',
            ga_category:'mark_lp02',
            ga_label:'mark_lp02_month',
            ga_value: 1
          })">今すぐ占う</div>
      </div>
    </div>

    <youtube-list
      block-subtitle="生年月日で占う「MITSURI」"
      :youtube-list="youtubeList"
    />

    <lp-footer :color-scheme="colorScheme" :menu-list="footerMenuList" />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import * as type from '@/utvStore/store/mutation-types'
import { BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import { COLOR_SCHEME, YOUTUBE_LIST } from './basicInfos'
import YoutubeList from '@/utvStore/components/MarkLp/partials/YoutubeList'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'

export default {
  name: 'HouenLp1',
  components: {
    swiper,
    swiperSlide,
    YoutubeList,
    LpFooter,
  },
  data(){
    return {
      bannerChangeNum: 1,
    }
  },
  computed: {
    colorScheme() {
      return COLOR_SCHEME
    },
    footerMenuList() {
      return [...DEFAULT_FOOTER_MENULIST]
    },
    swiperOption() {
      return {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          // disableOnInteraction: false,
        },
        loop: true,
        loopAdditionalSlides: 1,
      }
    },
    swiperOption2() {
      return {
        ...this.swiperOption,
        autoplay: {},
        loop: false,
        noSwiping: true,
        allowTouchMove: false,
      }
    },
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
      }
    },
    youtubeList() {
      return YOUTUBE_LIST
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.colorScheme)
  },
  mounted() {
    /*
    setInterval(()=>{
      let num = this.bannerChangeNum + 1
      this.bannerChangeNum = num > 2 ? 1 : num
    }, 1500)
     */
    setTimeout(() => {
      // 突貫処理：トップビジュアルの高さがウインドウ高より高いと不具合
      if (window.innerHeight < 900) {
        this.$refs.lpblock1.classList.add('intersecting')
      } // ここまで
    },500)
  },
  methods: {
    onLinkClick(data){
      const sendParams = {}
      if(!!data.ga_category) sendParams.event_category = data.ga_category
      if(!!data.ga_label) sendParams.event_label = data.ga_label
      if(!!data.ga_value) sendParams.value = data.ga_value
      if(!!sendParams.event_category || !!sendParams.event_label || !!sendParams.value) {
        gtag('event', 'click', sendParams)
      }


      switch (data.target){
        case 'utv-userinput':
          location.href = '/user/input'
          break
        case 'utv-login':
          location.href = '/user/login'
          break
        case 'utv-basicinput':
          location.href = '/recommend/lp/1/basic/input'
          break
        case 'utv-yearluck':
          location.href = '/2022_luck'
          break
      }
    }
  }
}</script>

<style scoped lang="scss">
$pink: #ff6f93;
$lightpink: #ffe2eb;
$lightblue: #d7fbff;
$purple: #796deb;


// FOT-筑紫A丸ゴシック Std R
.tsuku-maru {
  font-family: fot-tsukuardgothic-std, sans-serif;
  font-weight: 400;
  font-style: normal;
}

// FOT-筑紫A丸ゴシック Std B
.tsuku-maru-b {
  font-family: fot-tsukuardgothic-std, sans-serif;
  font-weight: 700;
  font-style: normal;
}

.img-wrap {
  width: 100%;
  position: relative;
  .upper {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.btn-area {
  width: 100%;
  text-align: center;
  .tgt-btn {
    @extend .tsuku-maru-b;
    display: inline-block;
    padding: 7px 0;
    border: 1px solid var(--key-color);
    border-radius: 50px;
    background: var(--key-color);
    //transition: all 500ms ease-out 500ms;
    //opacity: 0;
    //transform: translate(0, 40px);
    //font-weight: bold;
    font-size: 21px;
    color: #fff;
    width: 80%;
    user-select: none;
    cursor: pointer;
    -webkit-text-stroke: 0.6px white;
    margin-bottom: 8px;
    &.target-elm-purple {
      border: 1px solid $purple;
      background: $purple;
      .purple-mintext {
        -webkit-text-stroke: initial;
      }
    }

    /*
    &.intersecting {
      opacity: 1;
      transform: translate(0, 0);
    }
     */
  }
  .notice {
    font-size: 12px;
    display: block;
    width: 100%;
  }
}


.slide-area {
  padding: 0 7%;
  .notice {
    font-size: 10px;
    display: block;
    line-height: 13px;
    padding: 4px 0 16px;
    text-align: left;
    width: 100%;
  }
}

.lp-block {
  color: black;
  width: 100%;
  // height: 100vh;
  text-align: center;
  padding: 0;
  padding-top: 24px;
  img {
    width: 100%;
    display: block;
  }
}

.lp-block1 {
  background: white;
  padding: 0;
  .top-visual {
    overflow: hidden;
    .img-wrap {
      .upper {
        z-index: 20;
      }
      .obj1 {
        transition: all 500ms ease-out 0s;
        top: 6%;
        opacity: 0;
      }
      .obj2 {
        transition: all 500ms ease-out 1200ms;
        transform: translate(0, 10px);
        opacity: 0;
        top: 19%;
      }
      .obj3 {
        transition: all 500ms ease-out 1000ms;
        transform: translate(-10px, 0);
        opacity: 0;
        top: 21%;
      }
      .obj4 {
        transition: all 1200ms ease-out 400ms;
        filter: blur(3px);
        opacity: 0;
        bottom: 0;
        top: auto;
      }
      .numbers {
        z-index: 10;
        &.num01 {
          animation: anim-numbers 3000ms ease-out 0s infinite;
          top: auto;
          left: -12.5%;
          right: auto;
          width: 28%;
          display: block;
          bottom: 5.5%;
        }
        &.num02 {
          animation: anim-numbers 4600ms ease-out 0s infinite;
          top: auto;
          left: 12%;
          right: auto;
          width: 12%;
          display: block;
          bottom: 33.5%;
        }
        &.num03 {
          animation: anim-numbers 2800ms ease-out 0s infinite;
          top: 38.5%;
          left: auto;
          right: 27.2%;
          width: 9.5%;
          display: block;
          bottom: auto;
        }
        &.num04 {
          animation: anim-numbers 3800ms ease-out 0s infinite;
          top: auto;
          left: auto;
          right: -9.5%;
          width: 20%;
          display: block;
          bottom: 21%;
        }
        &.num05 {
          animation: anim-numbers 4200ms ease-out 0s infinite;
          top: 21.5%;
          left: auto;
          right: 18%;
          width: 15%;
          display: block;
          bottom: auto;
        }
        &.num06 {
          animation: anim-numbers 3600ms ease-out 0s infinite;
          top: 23%;
          left: 28.5%;
          right: auto;
          width: 9.5%;
          display: block;
          bottom: auto;
        }
        &.num07 {
          animation: anim-numbers 4000ms ease-out 0s infinite;
          top: -5.2%;
          left: 7.6%;
          right: auto;
          width: 17.5%;
          display: block;
          bottom: auto;
        }
        &.num08 {
          animation: anim-numbers 3400ms ease-out 0s infinite;
          top: -13.8%;
          left: auto;
          right: 12.2%;
          width: 22%;
          display: block;
          bottom: auto;
        }
      }
      .bgtop {
        overflow: hidden;
        img {
          margin-top: -10%;
          opacity: 0;
        }
      }
    }
  }
  .obj5 {
    transition: all 500ms ease-out 1200ms;
    opacity: 0;
    transform: translate(0, 10px);
  }
  .btn-area {
    transition: all 800ms ease-out 2000ms;
    opacity: 0;
    transform: translate(0, 20px);
    padding: 8px 0 16px;
    .login-link {
      text-decoration: underline;
    }
  }
  &.intersecting {
    .top-visual {
      .img-wrap {
        .obj1 {
          opacity: 1;
        }
        .obj2,
        .obj3 {
          opacity: 1;
          transform: translate(0, 0);
        }
        .obj4 {
          filter: none;
          opacity: 1;
        }
      }
    }
    .obj5,
    .btn-area {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
}

.lp-block2 {
  padding: 0 0 48px;
  background: url(/static/img/mark_lp/houen/hoen_m_lp_02_bg.png) no-repeat top center,
    url(/static/img/mark_lp/houen/hoen_m_lp_02_bg_shadow.png) no-repeat top center #fed04d;
  background-size: 100% auto;
  .img-wrap {
    .face {
      transition: all 200ms ease-out 0s;
      opacity: 0;
    }
    .fuki {
      transition: all 500ms ease-out 500ms;
      opacity: 0;
      transform: scale(0.8) translate(-30px, -20px);
    }
    &.intersecting {
      .face,
      .fuki {
        opacity: 1;
        transform: scale(1) translate(0, 0);
      }
    }
  }
  .btn-area {
    .tgt-btn {
      transition: all 800ms ease-out 100ms;
      opacity: 0;
      transform: translate(0, 20px);
    }
    &.intersecting {
      .tgt-btn {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}

.lp-block3 {
  padding: 0 0 48px;
  background: white;
  .slide-area {
    padding: 0 7% 8px;
  }
  .btn-area {
    .tgt-btn {
      transition: all 800ms ease-out 100ms;
      opacity: 0;
      transform: translate(0, 20px);
    }
    &.intersecting {
      .tgt-btn {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}

.lp-block4 {
  padding: 0 0 40px;
  background: url(/static/img/mark_lp/houen/hoen_m_lp_03_bg.png) repeat-y top center;
  background-size: 100% auto;
  .btn-area {
    .tgt-btn {
      transition: all 800ms ease-out 100ms;
      opacity: 0;
      transform: translate(0, 20px);
    }
    &.intersecting {
      .tgt-btn {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}

.lp-block5 {
  padding: 16px 0 40px;
  background: white;
  .btn-area {
    .tgt-btn {
      transition: all 800ms ease-out 100ms;
      opacity: 0;
      transform: translate(0, 20px);
    }
    &.intersecting {
      .tgt-btn {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}

.lp-block6 {
  padding: 32px 0 32px;
  background: url(/static/img/mark_lp/houen/hoen_m_lp_04_bg.png) no-repeat top center #ffe6df;
  background-size: 100% auto;
  .btn-area {
    .tgt-btn {
      transition: all 800ms ease-out 100ms;
      opacity: 0;
      transform: translate(0, 20px);
    }
    &.intersecting {
      .tgt-btn {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}

.lp-block7 {
  padding: 16px 0 40px;
  background: white;
  .btn-area {
    &.upper {
      padding: 16px 0 24px;
    }
    &.middle {
      padding: 16px 0 8px;
    }
    &.lower {
      .yearluck {
        background: #796deb;
        line-height: 1;
        border: 1px solid #796deb;
        margin-top: 6px;
        padding: 12px;
        .subtitle {
          display: block;
          width: 100%;
          font-size: 13px;
          -webkit-text-stroke: 0;
          margin-bottom: 4px;
        }
      }
    }
    .tgt-btn {
      transition: all 800ms ease-out 100ms;
      opacity: 0;
      transform: translate(0, 20px);
      &.tgt-btn2 {
        transition: all 800ms ease-out 500ms;
      }
    }
    &.intersecting {
      .tgt-btn {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}

.lp-block8 {
  padding: 32px 0 24px;
  background: url(/static/img/mark_lp/houen/hoen_m_lp_05_bg_01.png) no-repeat top center #ffecc1;
  background-size: 100% auto;
  .btn-area {
    padding: 16px 0 0;
    .tgt-btn {
      transition: all 800ms ease-out 100ms;
      opacity: 0;
      transform: translate(0, 20px);
    }
    &.intersecting {
      .tgt-btn {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
}
@keyframes anim-numbers {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(0, 5px);
  }
  50% {
    transform: translate(0, 0);
  }
  75% {
    transform: translate(0, -5px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/MarkLp/Houen/Lp1/HoueniLp1.vue